import { useSelectors } from '@exodus/headless-react';
import { useSelector } from 'react-redux';
import { useMemo } from 'react';
import { useValidationContext } from '../context/validation.js';
import useFromAsset from './use-from-asset.js';
import { useQuoteContext } from '../context/quote.js';
const useFeeDetails = () => {
    const selectors = useSelectors();
    const quote = useQuoteContext();
    const fee = quote.value?.fee;
    const { preventFromExchanging } = useValidationContext();
    const [fromAsset] = useFromAsset();
    const getFiatValue = useSelector(selectors.fiatBalances.conversions)[fromAsset.feeAsset.name];
    const useFee = !!fee && !preventFromExchanging;
    return useMemo(() => ({
        fee: useFee ? fee : undefined,
        feeFiat: useFee && getFiatValue ? getFiatValue(fee) : undefined,
    }), [useFee, fee, getFiatValue]);
};
export default useFeeDetails;
